module.exports = __webpack_public_path__ + "4203903e6d4266152772a526e2e77b04.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Characters/cow.png
// module id = 634
// module chunks = 0